import {
  faBolt,
  faBookOpen,
  faCancel,
  faClock,
  faDollarSign,
  faEdit,
  faFire,
  faImage,
  faLeaf,
  faUser,
  faUtensils,
  faWheatAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createRecipe } from "../components/api";

function CreateRecipe() {
  const [recipe, setRecipe] = useState({});
  const navigate = useNavigate();

  const formIsValid = () => {
    if (
      !recipe.title ||
      !recipe.description ||
      !recipe.calories ||
      !recipe.portionSize ||
      !recipe.cookingMinutes ||
      !recipe.ingredients ||
      !recipe.instructions
    ) {
      // Display an error message or take appropriate action
      console.error("Please fill in all required fields.");
      return;
    }else{
      return true;
    }
  }
  const handleCreateRecipe = () => {
    // Validate required fields
 
    if(formIsValid){
      let ingredientsArray = recipe.ingredients.split("\n");
      recipe.ingredients = ingredientsArray;
      let instructionsArray = recipe.instructions.split("\n");
      recipe.instructions = instructionsArray;
  
      createRecipe(recipe)
        .then((newRecipeId) => {
          navigate(`/`);
        })
        .catch((error) => {
          console.error("Error creating recipe:", error);
        });
    }else{
      alert('All fields must be filled out');
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox") {
      setRecipe((prevRecipe) => ({
        ...prevRecipe,
        [name]: checked,
      }));
    } else {
      setRecipe((prevRecipe) => ({
        ...prevRecipe,
        [name]: value,
      }));
    }
  };

  return (
    <div className="container editRecipe_wrapper">
      <div>
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => {
            window.location = `/`;
          }}
        >
          <FontAwesomeIcon icon={faCancel} /> Cancel
        </button>
      </div>

      <div className="editRecipe_container recipe-details-container">
        <div className="edit-form">
          <div className="mb-3">
            <div className="image-preview">
              <img
                src={recipe.imageURL ? recipe.imageURL : process.env.PUBLIC_URL + '/food-placeholder.png'}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://theme-assets.getbento.com/sensei/a42cf8c.sensei/assets/images/catering-item-placeholder-704x520.png";
                }}
                style={{
                  width: "auto",
                  height: "520px",
                  objectFit: "cover",
                  borderRadius: "5px",
                }}
              />
            </div>

            <label className="form-label">
              <FontAwesomeIcon icon={faImage} /> Image URL (Preview):
            </label>
            <input
              type="text"
              name="imageURL"
              value={recipe.imageURL || ""}
              onChange={handleInputChange}
              className="form-control"
              required // Make this field required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              <FontAwesomeIcon icon={faUtensils} /> Title:
            </label>
            <input
              type="text"
              name="title"
              value={recipe.title || ""}
              onChange={handleInputChange}
              className="form-control"
              required // Make this field required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              Cuisine (e.g. Italian, Mexican):
            </label>
            <input
              type="text"
              name="cuisine"
              value={recipe.cuisine || ""}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Optional - type of cuisine"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Difficulty:</label>
            <select
              name="difficulty"
              value={recipe.difficulty || ""}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">Select difficulty</option>
              <option value="Easy">Easy</option>
              <option value="Medium">Medium</option>
              <option value="Hard">Hard</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">
              <FontAwesomeIcon icon={faBookOpen} /> Description:
            </label>
            <textarea
              name="description"
              value={recipe.description || ""}
              onChange={handleInputChange}
              className="form-control"
              required // Make this field required
            />
          </div>

          <div className="mb-3 flex flex-row row">
            <div className="col">
              <label className="form-label">
                <FontAwesomeIcon icon={faFire} /> CAL:
              </label>
              <input
                type="number"
                name="calories"
                value={recipe.calories || ""}
                onChange={handleInputChange}
                className="form-control"
                required // Make this field required
              />
            </div>

            <div className="col">
              <label className="form-label">
                <FontAwesomeIcon icon={faUser} /> Person per portion:
              </label>
              <input
                type="number"
                name="portionSize"
                value={recipe.portionSize || ""}
                onChange={handleInputChange}
                className="form-control"
                required // Make this field required
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">
              <FontAwesomeIcon icon={faClock} /> Cooking time in minutes:
            </label>
            <input
              type="number"
              name="cookingMinutes"
              value={recipe.cookingMinutes || ""}
              onChange={handleInputChange}
              className="form-control"
              required // Make this field required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              <FontAwesomeIcon icon={faEdit} /> INGREDIENTS:
              <small className="form-text text-muted">
                Separate each ingredient with a new line. e.g.,
                <br></br> 1 cup of flour <br></br> 2 tsp baking powder
              </small>
            </label>
            <textarea
              name="ingredients"
              value={recipe.ingredients || ""}
              onChange={handleInputChange}
              className="form-control"
              required // Make this field required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">
              <FontAwesomeIcon icon={faBookOpen} /> RECIPE:
              <small className="form-text text-muted">
                Separate each instruction with a new line. e.g.,
                <br></br> 1. Preheat oven to 350 degrees <br></br> 2. Mix flour and baking powder
              </small>
            </label>
            <textarea
              name="instructions"
              value={recipe.instructions || ""}
              onChange={handleInputChange}
              className="form-control"
              required // Make this field required
            />
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              name="vegan"
              checked={recipe.vegan || false}
              onChange={handleInputChange}
              className="form-check-input"
            />
            <label className="form-check-label">
              <FontAwesomeIcon icon={faLeaf} /> Vegan
            </label>
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              name="glutenFree"
              checked={recipe.glutenFree || false}
              onChange={handleInputChange}
              className="form-check-input"
            />
            <label className="form-check-label">
              <FontAwesomeIcon icon={faWheatAlt} /> Gluten free
            </label>
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              name="highProtein"
              checked={recipe.highProtein || false}
              onChange={handleInputChange}
              className="form-check-input"
            />
            <label className="form-check-label">
              <FontAwesomeIcon icon={faBolt} /> High-protein
            </label>
          </div>

          <div className="mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                name="budgetFriendly"
                checked={recipe.budgetFriendly || false}
                onChange={handleInputChange}
                className="form-check-input"
              />
              <label className="form-check-label">
                <FontAwesomeIcon icon={faDollarSign} /> Budget-Friendly
              </label>
            </div>
            <small className="text-muted ms-4">
              Perfect for students: costs less than €15 per person and quick to make
            </small>
          </div>

          <button onClick={handleCreateRecipe} className="btn btn-primary">
            Create Recipe
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateRecipe;
